"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GrantRoleButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const grantRole_json_1 = __importDefault(require("@framework/abis/json/AccessControlFacet/grantRole.json"));
const utils_1 = require("../../../utils");
const dialogs_1 = require("../../../dialogs");
const dialog_1 = require("./dialog");
const GrantRoleButton = (props) => {
    const { className, contract, contract: { address, contractSecurity, accessControls }, disabled, variant, } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { openDialog, closeDialog } = (0, dialogs_1.useGlobalDialogFormCallbacks)();
    const hasPermission = accessControls.some(item => item.role === types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE);
    const { execute: metaFnExecute } = (0, react_hooks_eth_1.useMetamask)(async (values) => {
        return writeContractAsync({
            address: address,
            abi: grantRole_json_1.default,
            functionName: "grantRole",
            args: [types_1.AccessControlRoleHash[values.role], values.address],
        });
    });
    const handleGrantRoleConfirmed = async ({ data }) => {
        await metaFnExecute(data).finally(() => {
            closeDialog();
        });
    };
    const handleGrantRole = () => {
        openDialog(dialogs_1.GlobalDialogKeys.GRANT_ROLE, contract, {
            initialValues: {
                role: types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE,
                address: "",
            },
            validationSchema: dialog_1.grantRoleFieldsValidation,
            message: "dialogs.grantRole",
            testId: "AccessControlGrantRoleForm",
            onExternalConfirm: handleGrantRoleConfirmed,
        });
    };
    if (contractSecurity !== types_1.ContractSecurity.ACCESS_CONTROL) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleGrantRole, icon: icons_material_1.AccountCircle, message: "form.buttons.grantRole", className: className, dataTestId: "GrantRoleButton", disabled: disabled || (0, utils_1.shouldDisableByContractType)(contract) || !hasPermission, variant: variant }));
};
exports.GrantRoleButton = GrantRoleButton;
//# sourceMappingURL=index.js.map